import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { Step, Term } from '@fcp/lib-ui';
import {
  CMSAuthService,
  Token,
} from '../../essentials/cms/auth/cms-auth.service';
import { CMSContentService } from '../../essentials/cms/content/cms-content.service';

@Component({
  selector: 'fcp-filter-pension',
  templateUrl: './pension.component.html',
  styleUrls: ['./pension.component.scss'],
})
export class FilterPensionComponent implements OnInit {
  public currentStepIndex = 0;
  public steps: Observable<Array<Step>>;
  public termsSearched: Observable<Array<Term>>;
  public termSearched: Array<Term> = [];

  public btnFooterPrev = {
    title: 'Se você tem um plano de Previdência, acesse área exclusiva',
  };

  // public link = {
  //   url: '/',
  //   label: 'Já tenho um Plano Funcesp'
  // };

  constructor(
    private router: Router,
    private cmsAuthService: CMSAuthService,
    private cmsContentService: CMSContentService
  ) {}

  ngOnInit() {
    window?.scrollTo(0, 0);
    this.load();
  }

  load() {
    this.steps = of([]);
    this.termsSearched = of([]);
    let token = this.cmsAuthService.getToken();
    if (!token) {
      this.cmsAuthService.auth().subscribe((newToken: Token) => {
        token = newToken.token_type + ' ' + newToken.access_token;
        this.cmsAuthService.setToken(token);
        this.getContent();
      });
    } else {
      this.getContent();
    }
  }

  getContent() {
    this.cmsContentService.getFilterPension().subscribe((resp) => {
      this.steps = resp;
    });
  }

  public searchTerm(term) {
    this.cmsContentService.getPensionPlans(term).subscribe((resp) => {
      this.termsSearched = resp;
    });
  }

  public termWasSeleted(term) {
    if (term.childrens.length === 1) {
      this.router.navigate([term.childrens[0].link]);
    } else {
      this.termSearched = term.childrens;
      this.currentStepIndex = 1;
    }
  }

  public clearTerm(term) {
    this.currentStepIndex = 0;
    this.termsSearched = of([]);
    this.termSearched = [];
  }
}
